import makeApiRequest from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';

export const getGatewayListData =
(organisation: string) => makeApiRequest({
  method: 'GET',
  url: `${API_URL.gateways}`,
  organisation,
});
